import { useMemo } from 'react';

import Lottie from 'react-lottie';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import type { Toast } from 'domain/toast';

import checkmarkAnimation from './checkmark_animation.json';
import { StyledSuccessLottieContainer } from './styles';

export const ToastIcon = ({ toast }: { toast: Toast }) => {
  const animationOptions = useMemo(
    () => ({ animationData: checkmarkAnimation, autoplay: true, loop: false, height: '40px', width: '40px' }),
    []
  );

  if (toast.variant === 'success') {
    return (
      <StyledSuccessLottieContainer>
        <Lottie options={animationOptions} />
      </StyledSuccessLottieContainer>
    );
  }

  if (toast.icon) {
    return (
      <SWReactIcons
        iconName={toast.icon}
        iconColor={toast.iconColor || colorsPalettes.carbon[0]}
        size={toast.iconSize || 'xs'}
      />
    );
  }

  return null;
};
